export default function transformUploadRequest(data) {
  if (data?.meta) {
    data = { ...data, meta: JSON.stringify(data.meta) };
  }
  return data;
}
